import { render } from "./ServiceIndex.vue?vue&type=template&id=f830b234&scoped=true"
import script from "./ServiceIndex.vue?vue&type=script&lang=js"
export * from "./ServiceIndex.vue?vue&type=script&lang=js"

import "./ServiceIndex.vue?vue&type=style&index=0&id=f830b234&scoped=true&lang=css"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f830b234"]])

export default __exports__